import globalFnFactory from 'components/globalFn/globalFnFactory'

export function calculateTax(amt, taxrate, isTax) {
    let taxamount = 0
    if (isTax === '1') { // 含税
        taxamount = parseFloat(amt * taxrate / (1 + parseFloat(taxrate)))
        if (taxrate == '0.015') {
            taxamount = parseFloat(amt / 1.05 * 0.015)
        }
    } else { // 不含税
        taxamount = parseFloat(amt * taxrate)
        if (taxrate == '0.015') {
            taxamount = parseFloat(amt * 0.015 / 1.035)
        }
    }
    return taxamount
}

export const globalFn = globalFnFactory()

export function toFixed(num, n) {
    return parseFloat(num).toFixed(n)
}



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/invoiceUtils.js